module.exports = __webpack_public_path__ + "static/media/load_food.b829ba8d.jpg";